var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditTeal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.826 0.120438C10.9874 -0.0401461 11.2476 -0.0401461 11.409 0.120438L13.8796 2.59097C14.0401 2.75238 14.0401 3.01261 13.8796 3.17402L3.99744 13.0561C3.94391 13.1088 3.87804 13.1459 3.80557 13.164L0.511529 13.9875C0.371532 14.0229 0.223302 13.9818 0.120363 13.8797C0.0182477 13.7767 -0.0229313 13.6285 0.0124796 13.4885L0.835989 10.1944C0.854106 10.122 0.891168 10.0561 0.943873 10.0026L10.826 0.120438ZM1.60679 10.5049L0.97763 13.0224L3.49511 12.3932L13.0058 2.88249L11.1175 0.994186L1.60679 10.5049Z",
    fill: "#00CFC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17H0V16H16V17Z",
    fill: "#00CFC5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTeal);
export default __webpack_public_path__ + "static/media/edit_teal.59349220616f7c33751065be7f119da5.svg";
export { ForwardRef as ReactComponent };